import script from "./TaxDataFields.vue?vue&type=script&lang=ts&setup=true"
export * from "./TaxDataFields.vue?vue&type=script&lang=ts&setup=true"

import "./TaxDataFields.vue?vue&type=style&index=0&id=41fdf64a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41fdf64a"]])

export default __exports__